var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Linear, Power2, TweenLite } from "gsap";
import "pixi-spine";
import "pixi.js";
import { utilAnimation } from "../../utils/animation/utilAnimation";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../utils/sound/utilSound";
import { StateBuildingGraphics } from "../StateBuildingGraphics";
var Container = PIXI.Container;
var IdAnimTruck;
(function (IdAnimTruck) {
    IdAnimTruck["DriveEmpty"] = "drive_empty";
    IdAnimTruck["StopEmpty"] = "drive_empty_stop";
    IdAnimTruck["DriveFull"] = "drive_full";
    IdAnimTruck["IdleFull"] = "stop_full";
    IdAnimTruck["IdleEmpty"] = "stop_empty";
})(IdAnimTruck || (IdAnimTruck = {}));
var IdAnimDust;
(function (IdAnimDust) {
    IdAnimDust["Drive"] = "dust_trail";
    IdAnimDust["Start"] = "dust_trail_start";
    IdAnimDust["Stop"] = "dust_trail_stop";
})(IdAnimDust || (IdAnimDust = {}));
var BF2MarketTruck = /** @class */ (function (_super) {
    __extends(BF2MarketTruck, _super);
    function BF2MarketTruck() {
        var _this = _super.call(this) || this;
        _this.state = StateBuildingGraphics.Idle;
        _this.updateState = function (buildingState) {
            _this.state = buildingState;
            if (_this.truckAnim) {
                _this.update();
            }
        };
        _this.update = function () {
            switch (_this.state) {
                case StateBuildingGraphics.Idle:
                    _this.idle();
                    break;
                case StateBuildingGraphics.RunningProduction:
                    _this.startDelivery();
                    break;
                case StateBuildingGraphics.FinishedProduction:
                    _this.endDelivery();
                    break;
            }
        };
        _this.createStartDeliveryAnimation = function () {
            _this.startDeliveryTween = TweenLite.fromTo([_this.truckAnim, _this.dustAnim], BF2MarketTruck.AnimMoveTimeSeconds, {
                x: 0,
                y: 0,
            }, {
                ease: Power2.easeIn,
                x: 2300,
                y: 1130,
            });
            _this.startDeliveryTween.pause(0);
        };
        _this.createEndDeliveryAnimation = function () {
            _this.endDeliveryTween = TweenLite.fromTo([_this.truckAnim, _this.dustAnim], BF2MarketTruck.AnimMoveTimeSeconds * 0.5, {
                x: -1600,
                y: -800,
            }, {
                ease: Linear.easeNone,
                onUpdate: _this.onEndDeliveryUpdate,
                x: 0,
                y: 0,
            });
            _this.endDeliveryTween.pause(0);
            _this.truckAnim.position.set(0, 0);
        };
        _this.onEndDeliveryUpdate = function () {
            if (!_this.endDeliveryTween) {
                return;
            }
            var progress = _this.endDeliveryTween.progress();
            if (progress >= 0.7 && _this.getCurrentAnimName(_this.truckAnim) === IdAnimTruck.DriveEmpty) {
                // Sound
                utilSound.event(IdEventSoundCore.MarketContractFinish);
                // Truck anim
                _this.truckAnim.state.setAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimTruck.StopEmpty, false);
                _this.truckAnim.state.addAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimTruck.IdleEmpty, false, 0);
                // Dust anim
                _this.dustAnim.state.setAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimDust.Stop, false);
            }
        };
        _this.getCurrentAnimName = function (spineAnim) {
            return spineAnim.state.getCurrent(BF2MarketTruck.AnimTrackIdx).animation.name;
        };
        _this.idle = function () {
            _this.truckAnim.state.setAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimTruck.IdleEmpty, false);
            _this.dustAnim.visible = false;
        };
        _this.startDelivery = function () {
            // Sound
            utilSound.event(IdEventSoundCore.MarketContractStart);
            if (utilAnimation.isAnimationEnabled()) {
                // Truck anim
                _this.truckAnim.state.setAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimTruck.DriveFull, true);
                // Dust anim
                _this.dustAnim.visible = true;
                _this.dustAnim.state.setAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimDust.Start, false);
                _this.dustAnim.state.addAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimDust.Drive, true, 0);
                // Position anim
                _this.startDeliveryTween.restart();
            }
        };
        _this.endDelivery = function () {
            // Sound
            utilSound.event(IdEventSoundCore.MarketContractLoop);
            if (utilAnimation.isAnimationEnabled() ||
                _this.getCurrentAnimName(_this.truckAnim) !== IdAnimTruck.IdleEmpty) {
                // Truck anim
                _this.truckAnim.state.setAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimTruck.DriveEmpty, true);
                // Dust anim
                _this.dustAnim.visible = true;
                _this.dustAnim.state.setAnimation(BF2MarketTruck.AnimTrackIdx, IdAnimDust.Drive, true);
                _this.endDeliveryTween.restart();
            }
        };
        _this.init = function () {
            _this.truckAnim = utilAnimation.getSpineAnimation(BF2MarketTruck.TruckAnimId);
            _this.dustAnim = utilAnimation.getSpineAnimation(BF2MarketTruck.DustAnimId);
            _this.truckAnim.pivot.set(_this.truckAnim.width * 0.5, _this.truckAnim.height * 0.5);
            _this.truckAnim.scale.set(BF2MarketTruck.AnimScale, BF2MarketTruck.AnimScale);
            // Hard-coded values to align the animations
            _this.dustAnim.pivot.set(190, 150);
            _this.dustAnim.scale.set(BF2MarketTruck.AnimScale, BF2MarketTruck.AnimScale);
            _this.createStartDeliveryAnimation();
            _this.createEndDeliveryAnimation();
            _this.update();
            _this.addChild(_this.truckAnim, _this.dustAnim);
        };
        utilAnimation.getAnimLoaded$(BF2MarketTruck.TruckAnimId).subscribe(_this.init);
        return _this;
    }
    BF2MarketTruck.TruckAnimId = "market_truck";
    BF2MarketTruck.DustAnimId = "dust_trail";
    BF2MarketTruck.AnimScale = 0.65;
    BF2MarketTruck.AnimTrackIdx = 0;
    BF2MarketTruck.AnimMoveTimeSeconds = 5;
    return BF2MarketTruck;
}(Container));
export { BF2MarketTruck };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2MarketTruck.ts
// module id = 2166
// module chunks = 3